'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { Dropdown } from '@/components/features/Dropdown/Dropdown';
import { Search } from '@/components/ui/form/Search/Search';
import { FilledSpecialisation } from '@/api/specialisation/specialisation.types';
import { ResetButton } from '@/components/ui/ResetButton/ResetButton';
import s from './Doctors.module.scss';

interface Props {
  specialisations: FilledSpecialisation[];
  specialization: string;
  query: string;
}

export const DoctorsFilters = ({ specialisations, specialization, query }: Props) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const resetFilters = () => {
    const searchInput = document.getElementById('search-input') as HTMLInputElement | null;
    if (!searchInput) return;

    const params = new URLSearchParams(searchParams);

    searchInput.value = '';
    params.set('page', '1');
    params.delete('query');
    params.delete('specialisation_id__in');
    params.delete('show_more');

    replace(`${pathname}?${params.toString()}`);
  };

  const transformedSpecialisations = specialisations.map((item) => {
    return { id: item.id, name: item.title };
  });

  return (
    <div className={s.filtersWrapper}>
      <div className={s.filters}>
        <Search placeholder={'Поиск по ФИО врача'} noCross />
        <Dropdown
          paramsKey={'specialisation_id__in'}
          placeholder={'Специализация врача'}
          options={transformedSpecialisations}
          className={s.filters__dropdown}
        />
      </div>
      {(query || specialization) && (
        <ResetButton onClick={resetFilters} name={query && specialization && 'Очистить все'} />
      )}
    </div>
  );
};